import * as React from 'react';

function createSkinnedComponent(skin) {
  return function (props) {
    return React.createElement(skin, props);
  };
}

export { createSkinnedComponent };